// extracted by mini-css-extract-plugin
export default {"uploadFileBtn":"InputFile_uploadFileBtn__D3GLg","selectType":"InputFile_selectType__A3qk6","fileName":"InputFile_fileName__gsxMl","attachList":"InputFile_attachList__LN7O8"};